import { useEffect, useState } from "react";
import "./MarketingCampaigns.scss";
import { Navbar } from "../../components";
import useViewport from "../../hooks/useViewport";
import MarketingCampaignsNavbar from "../../components/MarketingCampaignsNavbar/MarketingCampaignsNavbar";
import { getAllMarketingCampaigns } from "../../api/marketingCampaigns.api";
import CampaignsCard from "../../components/CampaignsCard/CampaignsCard";
import MarketingCampaignNewForm from "../../components/MarketingCampaignNewForm/MarketingCampaignNewForm";

const MarketingCampaigns = ({ children, subTitle }) => {
  useViewport();

  const [marketingsCampaigns, setMarketingsCampaigns] = useState([]);
  const [openNewMarketingCampaign, setOpenNewMarketingCampaign] =
    useState(false);

  // 👇 1. Estado para el texto del buscador
  const [searchTerm, setSearchTerm] = useState("");

  async function fetchgetAllMarketingCampaigns() {
    const marketingsCampaigns = await getAllMarketingCampaigns();
    setMarketingsCampaigns(marketingsCampaigns);
  }

  useEffect(() => {
    fetchgetAllMarketingCampaigns();
  }, []);

  // 👇 2. Calculamos las campañas filtradas al vuelo
  const filteredCampaigns = marketingsCampaigns.filter((campaign) =>
    campaign.title.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="LayoutMarketingCampaigns">
      <Navbar title={subTitle} />
      <div className="LayoutMarketingCampaigns__contain">
        <MarketingCampaignsNavbar />

        <div className="LayoutMarketingCampaigns__contain__children">
          <h1>Campañas</h1>

          {/* 👇 3. Contenedor de las herramientas (Buscador + Botón Nuevo) */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <input
              type="text"
              placeholder="Buscar campaña por título..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "10px 15px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                width: "300px",
                fontSize: "14px",
              }}
            />

            <button
              type="button"
              className="subHeader__btn LayoutMarketingCampaigns__button"
              onClick={() => setOpenNewMarketingCampaign(true)}
            >
              Nuevo
            </button>
          </div>

          {openNewMarketingCampaign && (
            <MarketingCampaignNewForm
              setOpenNewMarketingCampaign={setOpenNewMarketingCampaign}
              marketingsCampaigns={marketingsCampaigns}
              setMarketingsCampaigns={setMarketingsCampaigns}
            />
          )}

          <div className="LayoutMarketingCampaigns__contain__children__campaigns">
            {/* 👇 4. Renderizamos las campañas FILTRADAS */}
            {filteredCampaigns.length !== 0 ? (
              filteredCampaigns.map((campaign) => {
                // Buscamos el índice real en el array original para que la edición no falle
                const realIndex = marketingsCampaigns.findIndex(
                  (c) => c._id === campaign._id,
                );

                return (
                  <CampaignsCard
                    key={campaign._id} // Es más seguro usar _id que title
                    campaign={campaign}
                    campaigns={marketingsCampaigns} // Pasamos la lista original completa
                    setCampaigns={setMarketingsCampaigns} // Modificamos la lista original completa
                    index={realIndex} // Pasamos el índice real
                  />
                );
              })
            ) : (
              // Mensaje por si buscan algo que no existe
              <p style={{ color: "#666", marginTop: "20px" }}>
                No se han encontrado campañas con ese nombre.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingCampaigns;
